/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Averageattempts1Inputs */

const zh_learn_averageattempts1 = /** @type {(inputs: Learn_Averageattempts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平均作答次数`)
};

const en_learn_averageattempts1 = /** @type {(inputs: Learn_Averageattempts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avg attempts`)
};

const es_learn_averageattempts1 = /** @type {(inputs: Learn_Averageattempts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intentos promedio`)
};

/**
* | output |
* | --- |
* | "Avg attempts" |
*
* @param {Learn_Averageattempts1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_averageattempts1 = /** @type {((inputs?: Learn_Averageattempts1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Averageattempts1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_averageattempts1(inputs)
	if (locale === "en") return en_learn_averageattempts1(inputs)
	return es_learn_averageattempts1(inputs)
});
export { learn_averageattempts1 as "learn_averageAttempts" }